import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { errMsg } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      nav(u?.onboarding_pending ? "/app" : "/app/executive", { replace: true });
    } catch (e2) {
      setErr(errMsg(e2));
    } finally { setBusy(false); }
  };

  const googleSignIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen pc-grid-bg flex items-center justify-center p-6">
      <div className="pc-card p-8 w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center">
            <span className="text-white font-bold" style={{fontFamily:'Outfit'}}>P</span>
          </div>
          <div className="font-bold text-white text-lg" style={{fontFamily:'Outfit'}}>Compass PM</div>
        </Link>
        <h1 className="text-2xl font-semibold text-white mb-1" style={{fontFamily:'Outfit'}}>Welcome back</h1>
        <p className="text-sm text-slate-400 mb-6">Sign in to your project workspace.</p>

        <button onClick={googleSignIn} data-testid="google-signin-btn"
          className="w-full mb-4 flex items-center justify-center gap-2 bg-white text-slate-900 px-4 py-2.5 rounded-lg font-medium hover:bg-slate-100">
          <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.9 32.9 29.4 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.5 6.1 29.5 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.5 16 18.9 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34.5 7.1 29.5 5 24 5 16.3 5 9.7 9.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 43c5.3 0 10.1-2 13.8-5.3l-6.4-5.4C29.4 33.9 26.9 35 24 35c-5.4 0-9.9-3.1-11.5-7.6l-6.5 5C9.5 38.7 16.2 43 24 43z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.3 5.6l6.4 5.4c-.4.4 7.1-5.2 7.1-15 0-1.3-.1-2.3-.4-3.5z"/></svg>
          Continue with Google
        </button>
        <div className="flex items-center gap-2 my-4"><div className="h-px bg-slate-800 flex-1"/><span className="text-xs text-slate-500">OR</span><div className="h-px bg-slate-800 flex-1"/></div>

        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <label className="text-xs uppercase tracking-widest text-slate-400">Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
              className="w-full px-3 py-2.5 rounded-lg border focus:outline-none focus:border-blue-500" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-slate-400">Password</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)}
              className="w-full px-3 py-2.5 rounded-lg border focus:outline-none focus:border-blue-500" />
          </div>
          {err && <div data-testid="login-error" className="text-sm text-rose-400">{err}</div>}
          <div className="flex justify-end">
            <Link to="/forgot-password" data-testid="forgot-password-link" className="text-xs text-slate-400 hover:text-blue-300">
              Forgot password?
            </Link>
          </div>
          <button data-testid="login-submit" disabled={busy}
            className="w-full bg-gradient-to-r from-blue-500 to-blue-700 text-white py-2.5 rounded-lg font-semibold shadow-lg shadow-blue-900/30 hover:from-blue-400 hover:to-blue-600 disabled:opacity-60">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <div className="mt-6 text-sm text-slate-400 text-center">
          No account? <Link to="/register" className="text-blue-400 hover:text-blue-300" data-testid="go-register-link">Create one</Link>
        </div>
      </div>
    </div>
  );
}
